import React from 'react';
import { Plus, Minus } from 'lucide-react';

const ZoomControls = ({
  canvasZoom,
  setCanvasZoom,
  showVersionsDropdown,
  sidebarPosition,
  sidebarCollapsed,
  sidebarWidth,
}) => {
  return (
    <div 
      className="absolute z-20 hidden md:block"
      style={{
        top: '50%',
        transform: 'translateY(-50%)',
        right: showVersionsDropdown 
          ? '400px'
          : sidebarPosition === 'right' && !sidebarCollapsed 
            ? `${sidebarWidth + 16}px` 
            : '16px'
      }}
    >
      <div className="bg-white dark:bg-gray-800 rounded-lg p-2 shadow-lg dark:shadow-gray-900/20 border border-gray-200 dark:border-gray-700 flex flex-col items-center space-y-2">
        <button
          onClick={() => setCanvasZoom(Math.min(2, canvasZoom + 0.1))}
          className="p-1.5 text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
          title="Zoom In"
        >
          <Plus className="w-4 h-4" />
        </button>
        
        <div className="relative h-32 flex items-center justify-center">
          <input
            type="range"
            min="10"
            max="200"
            step="5"
            value={canvasZoom * 100}
            onChange={(e) => setCanvasZoom(parseInt(e.target.value) / 100)}
            className="absolute w-32 h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary-600"
            style={{
              transform: 'rotate(-90deg)',
              transformOrigin: 'center'
            }}
          />
        </div>
        
        <button
          onClick={() => setCanvasZoom(Math.max(0.1, canvasZoom - 0.1))}
          className="p-1.5 text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
          title="Zoom Out"
        >
          <Minus className="w-4 h-4" />
        </button>
        
        <div className="text-xs text-gray-600 font-mono pt-2 border-t border-gray-200 dark:border-gray-700 w-full text-center">
          {Math.round(canvasZoom * 100)}%
        </div>
      </div>
    </div>
  );
};

export default ZoomControls;
